<template>
    <div class="w-[94%] flex flex-col items-center justify-center bg-white rounded-md pt-[60px] px-10 pb-10 mb-[20%]">
        <div class="text-primary-color font-semibold text-2xl">{{ storeName }}</div>
        <RouterLink :to="{ name: 'storeInfo', params: { store: storeCode } }"
            class="routerLink flex items-center justify-center bg-[#DDDDDD] rounded-full py-1.5 px-4 mt-4 mb-[30px]">
            <p class="button-icon text-[#4D4D4D] text-2xl mr-0.5">store</p>
            <div class="text-[#666666] text-base">營業資訊</div>
        </RouterLink>
        <div class="text-2xl font-semibold mb-6">
            免費登入
        </div>
        <button class="login_btn" @click="login">使用LINE登入</button>
        <div class="row_center_center mt-4 text-sm tracking-wider">
            <p style="color: #666666">若您選擇繼續，即表示您同意</p>
            <a href="https://www.okshop.tw/privacy/" target="_blank" style="color: #fd5001">條款與條件</a>
        </div>
    </div>
</template>
<script>
import {
    mapState,
    mapGetters,
} from 'vuex';
import { RouterLink } from "vue-router";
import apiData from "@/services/apiData";
export default {
    components: {
        RouterLink
    },
    computed: {
        ...mapState('userData', {
            userInfo: 'userInfo',
        }),
        ...mapGetters('userData', {
            isLogin: 'isLogin',
            vipLevel: 'vipLevel',
            phone: 'phone',
            name: 'name',
            avatar: 'avatar',
            storeCode: 'storeCode'
        }),
        ...mapGetters('basic', {
            storeName: 'storeName'
        })
    },
    data() {
        return {
        };
    },
    methods: {
        login() {
            let data = new apiData();
            data.store = this.storeCode;
            this.$store.dispatch('line/login', data)
        },
    }
};

</script>
<style lang="scss" scoped>
.login_btn {
    background-color: #06c755;
    border: none;
    width: 280px;
    height: 60px;
    border-radius: 6px;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
    box-shadow: 0px 3px 6px #00000029;
}

.routerLink {
    text-decoration: none;
}
</style>